import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import NewsletterCTA from "../home/components/NewsletterCTA";
import PodcastMission from "./components/PodcastMission";
import HostBio from "./components/HostBio";

export default function About() {
  return (
    <main className="min-h-screen bg-cream font-sans">
      <Navbar />

      {/* Page Hero */}
      <section
        className="relative pt-40 pb-20 overflow-hidden"
        style={{ background: "linear-gradient(160deg, #78350f 0%, #92400e 55%, #b45309 100%)" }}
      >
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/76975433268fe6dfcdce8bc3ac5b6f59.jpg"
            alt=""
            className="w-full h-full object-cover object-top opacity-15"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 text-center">
          <span className="inline-block font-sans text-xs font-semibold tracking-widest uppercase text-amber-300 mb-5">
            The Story Behind the Show
          </span>
          <h1 className="font-serif text-5xl lg:text-6xl font-bold text-amber-50 leading-tight mb-6">
            About The Humble Machine
          </h1>
          <p className="font-sans text-lg text-amber-100/75 max-w-xl mx-auto leading-relaxed">
            Honest, grounded conversations about AI — for the people who need it most.
          </p>
        </div>
      </section>

      <PodcastMission />
      <HostBio />

      <NewsletterCTA />
      <Footer />
    </main>
  );
}
